import React from 'react'
import Layout from '../layout/layout'
import SEO from "../layout/seo"
import './styles/ask.scss'
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-plugin-modal-routing-3'
import imgHeroLogo from "../images/ignite-summit-icon-turquoise.svg"

const ask = () => {
     
    return (
        <Layout attr="ask">
            <SEO title="Ignite Summit: Ask an Ignite Expert" />
            <div className="innerHeader">
                <div className="container">
                    <img src={imgHeroLogo} width={`57px`} height={`40px`} />
                    <h1>Ask an <span className="turquoise">Ignite Expert</span></h1>
                </div>
            </div>
            <div className="container header-content" >
                <p>One more reason to attend the June 14th, 2022  Ignite Summit live is that you can ask questions and receive answers. Apache Ignite Committers and experienced GridGain engineers will be available throughout the event at the "Ask an Ignite Expert" booth to answer any and all questions about the implementation and use of Apache Ignite.</p>
            </div>

            <div className="schedule-items">
                <div className="schedule-wrapper">
                    <div className="container">
                        
                        <section id="schedule" className="Shedule">
                            <h2 className="subHeader">June 14, 2022</h2>
                            <div className="scheduleFootnote">At a time convenient for you, drop in and ask your Ignite questions</div>

                            <article id="item1">
                                <div className="time">
                                    <div>9:30 am PDT</div>
                                    <div>12:30 pm EDT</div>
                                    <div>5:30 pm BST</div>
                                </div>
                                <div className={`sessionInfo`}>
                                    <p>Meet Pavel Tupitsyn and ask him about .NET, Ignite thin client, integrations, and more.</p>
                                    <div class="speakersTags">
                                        <div class="speaker">
                                            <div class="img-wrapper">
                                                <StaticImage alt="Pavel Tupitsyn" src="../images/ask/pavel_tupitsyn.jpg" />
                                            </div>
                                            <div class="txt-wrapper">
                                                <div class="name"><a href="https://recognition.gridgain.com/profile/b3134bfd-fb5b-4ad9-8e82-3bcb7e64522b" target="_blank">Review Pavel's non-code contributions&nbsp;<span>→</span></a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <article id="item2">
                                <div className="time">
                                    <div>10:30 am PDT</div>
                                    <div>1:30 pm EDT</div>
                                    <div>6:30 pm BST</div>
                                </div>
                                <div className={`sessionInfo`}>
                                    <p>If you are subscribed to the Apache Ignite user list or check Ignite questions on Stack Overflow, you for sure have met Stephen Darlington, GridGain engineer and dedicated community member who will answer questions about how to get started with Apache Ignite.</p>
                                    <div class="speakersTags">
                                        <div class="speaker">
                                            <div class="img-wrapper">
                                                <StaticImage alt="Stephen Darlington" src="../images/training-instructors/Stephen_Darlington.jpg" />
                                            </div>
                                            <div class="txt-wrapper">
                                                <div class="name"><a href="https://recognition.gridgain.com/profile/5816b8d5-a364-43f8-b1d4-9a52a4aa8aa2" target="_blank">Review Stephen's non-code contrubutions&nbsp;<span>→</span></a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <article id="item3">
                                <div className="time">
                                    <div>11:30 am PDT</div>
                                    <div>2:30 pm EDT</div>
                                    <div>7:30 pm BST</div>
                                </div>
                                <div className={`sessionInfo`}>
                                    <p>Rohit Dharampal, senior consultant at GridGain, is a trainer at spring sessions. All Ignite questions are welcome.</p>
                                    <div class="speakersTags">
                                        <div class="speaker">
                                            <div class="img-wrapper">
                                                <StaticImage alt="Rohit Dharampal" src="../images/training-instructors/rohit-dharampal.jfif" />
                                            </div>
                                            <div class="txt-wrapper">
                                                <div class="name"><a href="https://recognition.gridgain.com/profile/95428a79-8e6f-41b0-b9b9-8a510343c985" target="_blank">Review Rohit's non-code contributions&nbsp;<span>→</span></a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <article id="item3">
                                <div className="time">
                                    <div>1:30 pm PDT</div>
                                    <div>4:30 pm EDT</div>
                                    <div>9:30 pm BST</div>
                                </div>
                                <div className={`sessionInfo`}>
                                    <p>Join Apache Ignite Committer Andrey Alexandrov for answers to advanced Ignite questions.</p>
                                    <div class="speakersTags">
                                        <div class="speaker">
                                            <div class="img-wrapper">
                                                <StaticImage alt="Andrey Alexandrov" src="../images/ask/andrey_alexandrov.png" />
                                            </div>
                                            <div class="txt-wrapper">
                                                <div class="name"><a href="https://recognition.gridgain.com/profile/67c06f24-fb29-49ca-8f7b-fe1632e8f599" target="_blank">Review Andrey's non-code contributions&nbsp;<span>→</span></a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <article id="item4">
                                <div className="time">
                                    <div>3:00 pm PDT</div>
                                    <div>6:00 pm EDT</div>
                                    <div>11:00 pm BST</div>
                                </div>
                                <div className={`sessionInfo`}>
                                    <p>Alexander Korenshteyn, Senior Software Engineer at GridGain will answer your Ignite questions.</p>
                                    <div class="speakersTags">
                                        <div class="speaker">
                                            <div class="img-wrapper">
                                                <StaticImage alt="Andrey Alexandrov" src="../images/ask/alexander_korenshteyn.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </section>
                    </div>
                </div>
            </div>
            
        </Layout>
    )
}

export default ask